var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListIconGaugechart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11526_18728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5V17.5H17.5V8.33333H15.8333V15.8333H4.16667V4.16667H11.6667V2.5H2.5Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.83333V7.5H15.8333V5.83333H17.5V4.16667H15.8333V2.5H14.1667V4.16667H12.5V5.83333H14.1667Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79995 10C6.79995 8.2327 8.23264 6.80001 9.99995 6.80001V5.20001C7.34898 5.20001 5.19995 7.34905 5.19995 10C5.19995 12.651 7.34898 14.8 9.99995 14.8C12.6509 14.8 14.8 12.651 14.8 10H13.2C13.2 11.7673 11.7673 13.2 9.99995 13.2C8.23264 13.2 6.79995 11.7673 6.79995 10Z",
    fill: "#374E92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11526_18728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconGaugechart);
export default __webpack_public_path__ + "static/media/list_icon_gaugechart.8d04a05680880a599bf080ef30502a0e.svg";
export { ForwardRef as ReactComponent };